<template>
  <div class="upload-item">
    <Upload
      :show-upload-list="false"
      v-if="!value"
      type="drag"
      action="/"
      class="uploadBoxs"
      :before-upload="handleUpload"
    >
      <div class="uploading">
        <i class="iconfont icondaochu"></i>
        <span>上传</span>
      </div>
      <slot v-if="showSlot"></slot>
      <img :src="imgUrl" v-else/>
    </Upload>
    <Upload
      :show-upload-list="false"
      v-else
      type="drag"
      action="/"
      class="uploadBoxs"
      :before-upload="handleUpload"
    >
      <div class="demo-upload-list-cover" >
        <Icon type="ios-eye-outline" @click.stop="handleView(value)"></Icon>
        <Icon type="ios-trash-outline" @click.stop="handleRemove()" ></Icon>
      </div>
      <img src="@/static/images/cc_pdf_new.png" v-if="value&&value.includes('.pdf')" />
      <img :src="value" ref="img" :preview="previewId||_uid" v-else @click.stop/>
    </Upload>
  </div>
</template>
<script>
import { uploadFile } from "@/api/httpList";

export default {
  props: {
    imgUrl: null,//占位图
    value: null,
    previewId: null,
    type:{
      default:"png|jpg|jpeg"
    },
  },
  data() {
    return {
      showSlot:false,
      curImg: "",
    };
  },
  mounted(){
    if(this.$slots.default&&this.$slots.default.length){
      this.showSlot = true;
    }else{
      this.showSlot = false;
    }
  },
  methods: {
    checkType(path) {
      return path&&path
        .split(".")
        .pop()
        .toLowerCase();
    },
    handleView(path) {
      if(['png','jpg','jpeg'].includes(this.checkType(path))){
        this.$refs.img.click()
      }else{
        window.open(path, "_blank");
      }
    },
    handleUpload(file) {
      //  上传文件只能是 PDF/EXCEL/WORD/PPT/JPG/PNG 格式!
      const reg = new RegExp('\.('+this.type+')$');
      if (!reg.test(file.name.toLowerCase())) {
        this.$notice.error(`上传格式不正确，请上传${this.type.replace(/\|/g,'，')}格式文件`);
        return false;
      }

      let formData = new FormData();
      formData.append("file", file);
      uploadFile(formData).then((res) => {
        this.$emit("input", res.data[0].path);
      });
      return false;
    },
    handleRemove(){
      this.$emit("input", "");
    }
  },
};
</script>
<style lang="scss" scoped>
/deep/ .ivu-modal-body {
  padding: 0;
}
.upload-item {
  width: 262px;
  height: 162px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  border: 1px dashed #E5EEFF;
  background-color: #FAFCFF;
  /deep/{
    .ivu-upload-drag {
      border:0;
      background-color: transparent;
    }
    .ivu-upload {
      width: 100%;
      height: 100%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      > img {
        max-width: 100%;
        max-height: 100%;
      }
      .empty-icon {
        font-size: 54px;
        color: #F2F6FF;
      }
    }
  }
  .reload {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
    border-bottom-left-radius: 8px;
    width: 80px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #fff;
    background: rgba(0, 0, 0, 0.712);
  }
  .uploading {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
    border-bottom-left-radius: 4px;
    width: 58px;
    height: 20px;
    line-height: 18px;
    text-align: center;
    color: #fff;
    background: #236DFF;
    font-size: 12px;
    i {
      font-size: 12px;
      margin-right: 4px;
    }
    span {
      vertical-align: middle;
    }
  }
  .demo-upload-list-cover {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    align-items: center;
    justify-content: center;
    z-index: 1;
  }

  &:hover .demo-upload-list-cover {
    display: flex;
  }

  .demo-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
}
</style>
